import { Grid } from '@material-ui/core';
import React from 'react';

const CenterLayout = (props) => {
  return (
    <Grid
      container
      spacing={ 0 }
      direction='column'
      alignItems='center'
      justify='center'
      style={ { minHeight: '100vh' } }
    >
      {props.children}
    </Grid>
  );
};

export default CenterLayout;
